var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowcircleright(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Iconsax/Bold/arrowcircleright"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.1667 2.08325C7.42708 2.08325 2.75 6.76033 2.75 12.4999C2.75 18.2395 7.42708 22.9166 13.1667 22.9166C18.9062 22.9166 23.5833 18.2395 23.5833 12.4999C23.5833 6.76033 18.9062 2.08325 13.1667 2.08325ZM16.0729 13.052L12.3958 16.7291C12.2396 16.8853 12.0417 16.9583 11.8437 16.9583C11.6458 16.9583 11.4479 16.8853 11.2917 16.7291C11.1464 16.5821 11.0649 16.3837 11.0649 16.177C11.0649 15.9703 11.1464 15.7719 11.2917 15.6249L14.4167 12.4999L11.2917 9.37492C11.1464 9.2279 11.0649 9.02953 11.0649 8.82284C11.0649 8.61614 11.1464 8.41777 11.2917 8.27075C11.5937 7.96867 12.0938 7.96867 12.3958 8.27075L16.0729 11.9478C16.3854 12.2499 16.3854 12.7499 16.0729 13.052Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowcircleright);
export default __webpack_public_path__ + "static/media/arrowcircleright.a60facb3d6727e39d7d365d34d03e461.svg";
export { ForwardRef as ReactComponent };